import { Users } from "lucide-react";
import { InfoPage } from "../components/info/InfoPage";
import { FactorGrid, IllustratedSplit, InfoSection } from "../components/info/InfoSections";
import { StepTimeline } from "../components/info/StepTimeline";
import { RouteCards } from "../components/info/InfoExtras";
import { PHASES, PREPARE_TEXT, PROMISES, START_ROUTES, WERKWIJZE_NAV, WERKWIJZE_POINTS } from "../data/info/werkwijze";

export default function Werkwijze() {
  return (
    <InfoPage page="werkwijze" label="Werkwijze" eyebrow="Werkwijze" points={WERKWIJZE_POINTS} mediaKey="ka_werkwijze_hero" nav={WERKWIJZE_NAV}
      kbCategory="montage" faqTitle="Vragen over onze werkwijze" endTitle="Klaar voor de eerste stap?"
      badge={{ icon: Users, title: "Eén aanspreekpunt", text: "Van aanvraag tot oplevering" }}>
      <InfoSection id="starten" eyebrow="Starten" title="Drie manieren om te beginnen"
        lead="Kies de route die bij uw situatie past. Alle drie zijn vrijblijvend.">
        <RouteCards items={START_ROUTES} location="werkwijze-start" />
      </InfoSection>
      <InfoSection id="stappen" tone="slate" eyebrow="Stap voor stap" title="Van aanvraag tot oplevering in zeven stappen"
        lead="U weet vooraf wat u kunt verwachten en wie uw aanspreekpunt is.">
        <StepTimeline steps={PHASES} testid="werkwijze-timeline" />
      </InfoSection>
      <InfoSection id="afspraken" eyebrow="Onze afspraken" title="Wat u van ons kunt verwachten">
        <FactorGrid items={PROMISES} testid="werkwijze-promises" />
      </InfoSection>
      <InfoSection id="voorbereiding" tone="slate" eyebrow="Voorbereiding" title="Wat u vooraf kunt regelen">
        <IllustratedSplit mediaKey="ka_werkwijze_oplevering" text={PREPARE_TEXT} reverse testid="werkwijze-prepare-split" />
      </InfoSection>
    </InfoPage>
  );
}
